/**
 * ScrollToTop Component
 *
 * Automatically scrolls to top of page on route changes.
 * This fixes the issue where navigating via React Router
 * keeps the scroll position from the previous page.
 */

import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  // Use useLayoutEffect for synchronous scroll before paint
  useLayoutEffect(() => {
    // Scroll to top immediately
    window.scrollTo(0, 0);
  }, [pathname]);

  // Also use useEffect as backup with slight delay
  useEffect(() => {
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 0);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
